import React from 'react'

const Projects = () => {
  return (
    <>
      
      <h1>Projects awarded </h1>
    </>
  )
}

export default Projects

